
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hriste",
      function () {
        return require("private-next-pages/hriste/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hriste"])
      });
    }
  